<mdb-sidenav #sidenav class="fixed" [fixed]="true">
    <!-- Logo -->
    <li>
        <div class="logo-wrapper waves-light text-center">
            <a class="h-100" href="#">
                <img src="{{logoUrl}}" alt="{{logoTitle}}" class="mh-100 mw-100 p-0">
            </a>
        </div>
    </li>
    <li>
        <ul class="collapsible collapsible-accordion">
            <mdb-squeezebox [multiple]="false" aria-multiselectable="false" class="text-white">
                <!-- Simple link -->
                <mdb-item [ngClass]="{'no-collapse': !navItem.hasChildren}" *ngFor="let navItem of navItems">
                    <mdb-item-head *ngIf="!navItem.hasChildren" mdbRippleRadius (click)="handleItemClick(navItem, $event)" [routerLinkActive]="'active'"
                        [routerLink]="navItem.routerLink">
                        <i class="fa fa-hand-pointer-o"></i>{{navItem.name}}
                    </mdb-item-head>
                    <mdb-item-body *ngIf="!navItem.hasChildren"></mdb-item-body>

                    <mdb-item-head *ngIf="navItem.hasChildren" mdbRippleRadius>
                        <i class="fa fa-hand-pointer-o"></i>{{navItem.name}}
                    </mdb-item-head>
                    <mdb-item-body *ngIf="navItem.hasChildren">
                        <ul>
                            <li *ngFor="let child of navItem.children">
                                <a [routerLinkActive]="'active'" [routerLink]="child.routerLink" mdbRippleRadius>
                                    <i class="fa fa-hand-pointer-o"></i> {{child.name}}</a>
                            </li>
                        </ul>
                    </mdb-item-body>
                </mdb-item>
            </mdb-squeezebox>
        </ul>
</mdb-sidenav>


// WEBPACK FOOTER //
// ./src/app/theme/sidebar/sidebar.component.html